import AcuityConfigParser from './AcuityConfigParser';

export const ParserTypes = {
  ACUITY: 'acuity'
};

export const getConfigurationParser = type => {
  switch(type) {
    case ParserTypes.ACUITY:
      return new AcuityConfigParser();
      break;
  }
};


// WEBPACK FOOTER //
// ./src/Services/Parsers/ParserFactory.js